/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Row_ActionsInputs */

const cs_portals_row_actions = /** @type {(inputs: Portals_Row_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akce portálu`)
};

const en_portals_row_actions = /** @type {(inputs: Portals_Row_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal actions`)
};

/**
* | output |
* | --- |
* | "Portal actions" |
*
* @param {Portals_Row_ActionsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_row_actions = /** @type {((inputs?: Portals_Row_ActionsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Row_ActionsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_row_actions(inputs)
	return cs_portals_row_actions(inputs)
});